export const genesisFocus = Object.freeze({
  outline: 0,
  boxShadow: 'focusRing',
});
